var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PDF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.318,
    height: 13.576,
    viewBox: "0 0 10.318 13.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12971",
    "data-name": "Path 12971",
    d: "M21.246,7.3h3.089a.168.168,0,0,0,.17-.17h0a1,1,0,0,0-.363-.777L21.552,4.2a1.09,1.09,0,0,0-.7-.251h0A.251.251,0,0,0,20.6,4.2V6.656A.645.645,0,0,0,21.246,7.3Z",
    transform: "translate(-14.187 -3.941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12972",
    "data-name": "Path 12972",
    d: "M12.845,6.653V3.938H8.4A1.089,1.089,0,0,0,7.313,5.024v11.4A1.089,1.089,0,0,0,8.4,17.514h8.146a1.089,1.089,0,0,0,1.086-1.086V8.18H14.372A1.53,1.53,0,0,1,12.845,6.653Z",
    transform: "translate(-7.313 -3.938)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1e4a1e4bc2ac3e467f42d7b7c0b8d7cd.svg";
export { ForwardRef as ReactComponent };